export const ROOT = '/'
export const APP_PREFIX_PATH = '/app'
export const AUTH_PREFIX_PATH = '/auth'
export const UI_COMPONENTS_PREFIX_PATH = '/ui-components'
export const PAGES_PREFIX_PATH = '/pages'
export const DOCS_PREFIX_PATH = '/docs'
export const HOME_PREFIX_PATH = '/'
export const DASHBOARD_PREFIX_PATH = '/dashboard'
export const USERS_PREFIX_PATH = '/users'
export const CAREER_PREFIX_PATH = '/career'
export const RECRUITMENT_PREFIX_PATH = '/recruitment'
export const DEVELOPMENT_PLANNING_PREFIX_PATH = '/development-planning'
export const MY_PLANNING_PREFIX_PATH = '/my-planning'
export const ORGANIZATION_PREFIX_PATH = '/organization'
export const SUPPORT_TOOLS_PREFIX_PATH = '/support-tools'
export const TOOLS_PREFIX_PATH = '/tools'
export const ANALYTICS_PREFIX_PATH = '/analytics'
export const PROJECTS_PREFIX_PATH = '/projects'
export const RESOURCES_PREFIX_PATH = '/resources'
export const MAIN_SETTINGS_PREFIX_PATH = '/main-settings'
